import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'terms_conditions_documents_are_not_up_date'

export const dataPointDefinition = {
  retracedId: 'terms_conditions_documents_are_not_up_date',
  name: 'Terms and conditions documents are not up to date',
  description:
    'The intent of this option selection is to understand if terms and conditions documents between the facility and each worker are valid and up to date, i.e. a contract has not run out. ',
  meta: {
    slcpMeta: {
      key: 'rh-emp-21x',
      number: 'RH-EMP-14-2',
      masterType: 'Question',
      versionImported: '1.7.0',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'rh-emp-21x', version: '1.7.0', provider: 'slcp'}],
  sortingId: 34490,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
